module.exports = __webpack_public_path__ + "img/zongjie_grey.834a3e86.svg";